// any image must be in img folder with unique name
export const sliderServices = [
    {
        title: 'Architectural BIM Services',
        sliderImage: 'a1_3.webp',
        description: 'We create interactive architectural bim services 3D models for design presentation and effective design communication to aid Architectural consultants & contractors.',
        link: '/service/test-service',
        cardImage: '/img/a1_3.webp',
        icon: '/img/i1.webp'
    },
    {
        title: 'Structural BIM Services',
        sliderImage: 'a2_3.webp',
        description: 'We deliver structural BIM services to structural / civil engineers in order to build structures of immense strength and well-coordinated with other disciplines.',
        link: '/service/test-service',
        cardImage: '/img/a2_3.webp',
        icon: '/img/i2.webp'
    },
    {
        title: 'MEP BIM Services',
        sliderImage: 'a3_3.webp',
        description: 'We deliver MEP BIM services to MEP contractors and MEP consultants for obtaining coordinated clash free 3D models in a building design layout.',
        link: '/service/test-service',
        cardImage: '/img/a3_3.webp',
        icon: '/img/i3.webp'
    },
    {
        title: 'Infrastructure BIM Services',
        sliderImage: 'a4_3.webp',
        description: 'Enhance collaboration, better project understanding due to 3D visualization, enhanced communication between various parties and generation of dynamic design data that can ultimately be used to support operations, maintenance and asset management.',
        link: '/service/test-service',
        cardImage: '/img/a4_3.webp',
        icon: '/img/i4.webp'
    },
    {
        title: 'BIM Management',
        sliderImage: 'a5_2.webp',
        description: 'Al-Hady, your preferred partner for efficient Building Information Modeling BIM management. Throughout the course of the project, our comprehensive BIM management services promise improved collaboration and facilitated project execution.',
        link: '/service/test-service',
        cardImage: '/img/a5_2.webp',
        icon: '/img/i5.webp'
    },
    {
        title: 'BIM Advisory Services',
        sliderImage: 'a6_3.webp',
        description: 'The specific site for complete advisory solutions and BIM advisory services. Al-Hady providing unmatched knowledge and direction to your construction projects through creative approaches and patiently sound plans.',
        link: '/service/test-service',
        cardImage: '/img/a6_3.webp',
        icon: '/img/i6.webp'
    },
    {
        title: 'BIM Consulting Services',
        sliderImage: 'a7_3.webp',
        description: 'The advantage of our full range of BIM consulting services, where expertise and imagination combine to transform your construction projects. We offer a variety of consulting services designed to increase project efficacy, reduce costs, and boost overall performance. In the area of building information modeling, we are pioneers in the field.',
        link: '/service/test-service',
        cardImage: '/img/a7_3.webp',
        icon: '/img/i7.webp'
    },
    {
        title: 'Architectural Engineering Consultants',
        sliderImage: 'a8_2.webp',
        description: 'At Al-Hady, we are dedicated to transforming visions into reality through innovative architectural engineering solutions. As seasoned consultants, we bring a wealth of expertise to every project, ensuring excellence in design, functionality, and sustainability. Explore our services and discover how we can elevate your project to new heights.',
        link: '/service/test-service',
        cardImage: '/img/a8_2.webp',
        icon: '/img/i8_1.webp'
    },
    {
        title: 'BIM model audit',
        sliderImage: 'a9_3.webp',
        description: 'BIM model audit designed to ensure the accuracy integrity and compliance of your Building Information Models BIM. Our BIM auditing process involves meticulous analysis and evaluation, empowering you to confidently move forward with your construction projects.',
        link: '/service/test-service',
        cardImage: '/img/a9_3.webp',
        icon: '/img/i9_1.webp'
    },
    {
        title: 'BIM Innovations',
        sliderImage: 'a10_3.webp',
        description: 'The construction industry is undergoing a revolution thanks to bim innovations in Building Information Modeling BIM, which are changing project workflows and outcomes. At Engisoft, we welcome innovations in BIM and are bringing about significant changes in the planning, carrying out, and managing of projects.',
        link: '/service/test-service',
        cardImage: '/img/a10_3.webp',
        icon: '/img/i10.webp'
    },
    {
        title: 'BIM Implementation Services',
        sliderImage: 'a11_2.webp',
        description: 'The advantage of our Al-Hady is the ideal partner for establishing state-of-the-art Building Information Modeling BIM systems into practice. Our BIM implementation services have been specially designed to improve the effectiveness teamwork and general success of your project.',
        link: '/service/test-service',
        cardImage: '/img/a11_2.webp',
        icon: '/img/i11.webp'
    },
    {
        title: 'Outsourcing BIM Architects',
        sliderImage: 'a12_2.webp',
        description: 'In the fast-paced world of architectural design and construction, outsourcing BIM (Building Information Modeling) architects has become a strategic move for firms looking to enhance efficiency and focus on core competencies. At ENGISOFT, we offer top-notch BIM architectural outsourcing services tailored to meet the unique needs of your projects.',
        link: '/service/test-service',
        cardImage: '/img/a12_2.webp',
        icon: '/img/i12.webp'
    },
    {
        title: 'BIM STAFFING SERVICES',
        sliderImage: 'a13_3.webp',
        description: '',
        link: '/service/test-service',
        cardImage: '/img/a13_3.webp',
        icon: '/img/i13.webp'
    },
    {
        title: 'LANDSCAPE BIM SERVICES',
        sliderImage: 'a14_3.webp',
        description: '',
        link: '/service/test-service',
        cardImage: '/img/a14_3.webp',
        icon: '/img/i14_1.webp'
    },
    {
        title: 'INTERIOR BIM SERVICES',
        sliderImage: 'a15_3.webp',
        description: '',
        link: '/service/test-service',
        cardImage: '/img/a15_3.webp',
        icon: '/img/i15.webp'
    },
    {
        title: 'REVIT FAMILY CREATION',
        sliderImage: 'a16_2.webp',
        description: '',
        link: '/service/test-service',
        cardImage: '/img/a16_2.webp',
        icon: '/img/i16.webp'
    },
    {
        title: 'BIM SHOP DRAWINGS',
        sliderImage: 'a17_3.webp',
        description: '',
        link: '/service/test-service',
        cardImage: '/img/a17_3.webp',
        icon: '/img/i17.webp'
    },
    {
        title: 'FACADE BIM SERVICES',
        sliderImage: 'a18_3.webp',
        description: '',
        link: '/service/test-service',
        cardImage: '/img/a18_3.webp',
        icon: '/img/i18.webp'
    },


]
export const usedTools = [
    {
        title: 'AUTODESK REVIT',
        icon: '/img/p1_1.webp'
    },
    {
        title: 'AUTODESK AUTOCAD',
        icon: '/img/p2_1.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/p3_1.webp'
    },
    {
        title: '3DS MAX',
        icon: '/img/p4_1.webp'
    },
    {
        title: 'AUTODESK BIM 360',
        icon: '/img/p5_1.webp'
    },
    {
        title: 'DYNAMO',
        icon: '/img/p6_1.webp'
    },

    {
        title: 'AUTOCAD CIVIL 3D',
        icon: '/img/p7_1.webp'
    },
    {
        title: 'SKETCHUP',
        icon: '/img/p8_1.webp'
    },
    {
        title: 'LUMION',
        icon: '/img/p9_1.webp'
    },
    {
        title: 'VRAY',
        icon: '/img/p10.webp'
    },
    {
        title: 'SOFISTIK',
        icon: '/img/p11_1.webp'
    },
    {
        title: 'TEKLA STRUCTURES',
        icon: '/img/p12.webp'
    },
]
export const clients = [
    {
        title: 'AUTODESK REVIT',
        icon: '/img/c1.webp'
    },
    {
        title: 'AUTODESK AUTOCAD',
        icon: '/img/c2.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/c3.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/c4.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/c5.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/c6.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/c7_1.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/c8.webp'
    },
    {
        title: 'NAVISWORKS',
        icon: '/img/c9.webp'
    },

]

export const partners = [
    {
        title: 'AUTODESK REVIT',
        icon: '/img/partner1.webp'
    },
]
export const reviews = [
    {
        description: 'lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
        name: 'John Doe',
        image: '/img/person1_1.webp',
        jobTitle: 'Alhady Owner'
    },
    {
        description: 'lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
        name: 'John Doe',
        image: '/img/person2.webp',
        jobTitle: 'Alhady Owner'
    },
    {
        description: 'lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum',
        name: 'John Doe',
        image: '/img/person3_1.webp',
        jobTitle: 'Alhady Owner'
    },
]

export const portfolioData = [
    {
        cardImage: '/img/t-1_1_1.webp',
        title: 'Project Name 1',
        serviceCagegory: 'BIM'
    },
    {
        cardImage: '/img/t-2_1_1.webp',
        title: 'Project Name 1',
        serviceCagegory: 'BIM'
    },
    {
        cardImage: '/img/t-3_1.webp',
        title: 'Project Name 1',
        serviceCagegory: 'BIM'
    },
    {
        cardImage: '/img/t-4_1_2.webp',
        title: 'Project Name 1',
        serviceCagegory: 'BIM'
    },
    {
        cardImage: '/img/t-5_1_2.webp',
        title: 'Project Name 1',
        serviceCagegory: 'BIM'
    },
    {
        cardImage: '/img/t-6_1_2.webp',
        title: 'Project Name 1',
        serviceCagegory: 'BIM'
    },

]

export const ourTeam = [
  {
    Name: 'Mohamed Ibrahim Elhady',
    Position: 'Chairman'
  },
  {
    Name: 'RIZK ABDUL AZIM RIZK ALI',
    Position: 'BIM Manager'
  },
  {
    Name: 'ASHRAF ABDEL HAMID MOHAMED GHAMRI',
    Position: 'Eng.Structure Manager'
  },
  {
    Name: 'MOHAMED RASHAD ALI KHALIL',
    Position: 'HR Manager'
  },
  {
    Name: 'Ibrahim Khaled Ibrahim Ahmed Gad',
    Position: 'Eng. Team Leader Architectural BIM'
  },
  {
    Name: 'BASMA SALAH AWAD HAZZA',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'JANAT MUSTAFA ABDEL AZIM AHMED',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'SAAD MOHAMAD ALI ABDEL GHANI',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'KARIM MOHAMAD AL GHARIB AHMED MAHMOUD',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'KHALED MOHAMAD MOHAMAD GHAMS',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'ABDUL RAHMAN AL QADI',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'Ahmed Ashraf Mostafa Saad Mohamed Elgendy',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'KHALED MUKHTAR HASHEM MOHAMAD',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'AYA SALAH AL DIN AYOUB MOHAMAD ALSAYYID',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'KARIM ADEL ABDEL FATTAH ALI',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'Esraa Ashraf Kamel Mohamed',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'Sarah Mohamed Mohamed Sabry Ibrahim Badr',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'Ahmed Soliman Khalil Mohammed Soliman',
    Position: 'Eng.Architectural BIM'
  },
  {
    Name: 'ABDULRAHMAN_ANWAR_ABUAL_SAUD',
    Position: 'Eng.BIM Coordinator'
  },
  {
    Name: 'NOURHAN RIAD ABDEL GHANI EL ARABI',
    Position: 'Eng. Team Leader Infrastructure BIM'
  },
  {
    Name: 'MOHAMAD HASSAN AL SAYED METWALLY JIBRIL',
    Position: 'Eng. Infrastructure BIM'
  },
  {
    Name: 'HUSSEIN MOHAMED MOHAMED AFFAN',
    Position: 'Eng. Infrastructure BIM'
  },
  {
    Name: 'YOUSSEF MOHAMAD ABDULLAH AL SAYED',
    Position: 'Eng. Infrastructure BIM'
  },
  {
    Name: 'MOHAMED MUSTAFA MAHMOUD AHMED',
    Position: 'Eng. Infrastructure BIM'
  },
  {
    Name: 'Mohammed AlTayeb Hassan Ali Ahmed',
    Position: 'Eng. Infrastructure BIM'
  },
  {
    Name: 'Yousif Abdellatef Abdelaziz Ali',
    Position: 'Eng. Infrastructure BIM'
  },
  {
    Name: 'ALAA MOHAMMED HUSSEIN MOHAMED',
    Position: 'Eng.Structure'
  },
  {
    Name: 'MOHAMED MOHAMED ALI ABDELGHANI',
    Position: 'Eng.Structure BIM'
  },
  {
    Name: 'BASANT ATTIA ABDUL AZIZ HUSSEIN',
    Position: 'Eng.Structure'
  },
  {
    Name: 'Abdallah Samy Mohamed Mohamed',
    Position: 'Eng.Structure'
  },
  {
    Name: 'AMIR NASHAAT ALSAYYID MOHAMED',
    Position: 'Eng.Electrical BIM'
  }
]

export const ourProjects = [
    {
        id: 1,
        title:'Project Name',
        serviceCagegory:'serviceCagegory',
        homeCardImage: '/img/a-1_3.webp',

        projectImage: '/img/a-1_3.webp',
        projectDetails:{
            projectType:'projectType',
            client: 'client',
            year: 'year',
            location:'location',
            projectSize:'project size',
            projectTime:'project Time',
            pepoleWorked:'18',
            projectCost:'project cost',
            statisticsIcon:'/img/a-1_3.webp'
        },
        header:'project header',
        description:'project description',
        projectSamples:[
            {
                image: '/img/a-1_3.webp',
                title: 'Sample Title 1',
                description: 'Sample Description 1'
            },
            {
                image: '/img/a-1_3.webp',
                title: 'Sample Title 1',
                description: 'Sample Description 1'
            },
        ]
    },
    {
        id: 2,
        title:'Project Name',
        serviceCagegory:'serviceCagegory',
        homeCardImage: '/img/a-1_3.webp',

        projectImage: '/img/a-1_3.webp',
        projectDetails:{
            projectType:'projectType',
            client: 'client',
            year: 'year',
            location:'location',
            projectSize:'project size',
            projectTime:'project Time',
            pepoleWorked:'18',
            projectCost:'project cost',
        },
        header:'project header',
        description:'project description',
        projectSamples:[
            {
                image: '/img/a-1_3.webp',
                title: 'Sample Title 1',
                description: 'Sample Description 1'
            },
            {
                image: '/img/a-1_3.webp',
                title: 'Sample Title 1',
                description: 'Sample Description 1'
            },
        ]
    },
    {
        id: 3,
        title:'Project Name',
        serviceCagegory:'serviceCagegory',
        homeCardImage: '/img/a-1_3.webp',

        projectImage: '/img/a-1_3.webp',
        projectDetails:{
            projectType:'projectType',
            client: 'client',
            year: 'year',
            location:'location',
            projectSize:'project size',
            projectTime:'project Time',
            pepoleWorked:'18',
            projectCost:'project cost',
        },
        header:'project header',
        description:'project description',
        projectSamples:[
            {
                image: '/img/a-1_3.webp',
                title: 'Sample Title 1',
                description: 'Sample Description 1'
            },
            {
                image: '/img/a-1_3.webp',
                title: 'Sample Title 1',
                description: 'Sample Description 1'
            },
        ]
    },
]


